// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--76750";
export var hero_content = "styles-module--hero_content--f11c1";
export var image_container = "styles-module--image_container--d3b76";
export var text_container = "styles-module--text_container--09bf2";